import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const BankAccount = () => import('./views/Index.vue');

export default [
  {
    path: '/bank-account',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'BankAccount',
        component: BankAccount,
        meta: { title: i18n.global.t('bankAccount.bankAccount') },
      },
    ],
  },
];
